export default __webpack_public_path__ + "static/media/zapatillas.b0560434.jpg";